import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { fuseAnimations } from '@fuse/animations';
import * as catalogo from '../catalogo';
import * as backInter from 'app/auth/auth-data.model';

@Component({
  selector: 'correos',
  templateUrl: './correos.component.html',
  styleUrls: ['./correos.component.scss'],
  animations   : fuseAnimations
})
export class CorreosComponent implements OnInit {

  comunicacionEditor: any;
  @Input() actualizaEmail: Observable<any>;
  @Output() cambiaPaso: EventEmitter<number> = new EventEmitter();
  @Output() enviaDatosEditor: EventEmitter<any> = new EventEmitter();

  tipoCorreos = catalogo.tipoCorreos;

  // Datos certificar vigente
  productoActual: any;

  instituto: number;
  claveNativo: string;
  idiomas: any[] = [];

  tiposCorreos:any[] = [
    {tipo: 1}, //invitacon
    {tipo: 2}, //recordatorio
  ];

  constructor(
    private programacionService: ProgramacionService,
    private wizardService: WizardService,
  ) { }

  ngOnInit() {
    this.obtieneProductoActual();
    this.comunicacionEditor = this.actualizaEmail.subscribe( (datos) => {
      console.log("se envio datos desde componente editor: ",datos);
      this.checkCorreosGuardados();
    });
  }

  obtieneProductoActual(){
    /// obtiene el producto certificar vigente
    this.programacionService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      // let productos:backInter.prodCert[] = data.productosCertificar;
      let productos: any[] = [];
      switch (localStorage.getItem('tipoProducto')) {
        case '1': case 'c1': productos = data.productosCertificar; break;
        case '2': productos = data.productosMedir; break;
        case 'm1': productos = data.productosMedir2;
      }
      var BreakException = {};
      let fecha: any;
      let idProducto: any;
      try {
          productos.forEach( (producto) => {
            switch (localStorage.getItem('tipoProducto')) {
              case '1': case 'c1':
                fecha = producto.fechaCertificar;
                idProducto = producto.idCertificar;
              break;
              case '2':
                fecha = producto.fechaMedir;
                idProducto = producto.idMedir;
              break;
              case 'm1':
                fecha = producto.fechaProducto;
                idProducto = producto.idProducto;
              break;
            }
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoActual = producto;
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      this.obtieneIdiomasGuardados();
      this.getInstituto();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  obtieneIdiomasGuardados(){
    let datos: any = {};
    switch (localStorage.getItem('tipoProducto')) {
      case '1': case 'c1': datos = {fechaCertificar:this.productoActual.fechaCertificar}; break;
      case '2': datos = {productoId:this.productoActual.idMedir}; break;
      default: datos = {productoId:this.productoActual.idProducto};
    }
    this.programacionService.getIdiomasProdMedir(datos).subscribe( (data: backInter.getIdiomas) => {
      this.idiomas = data.idiomasMostrar;
      this.checkCorreosGuardados();
    });
  }

  getInstituto(){
    switch(this.wizardService.getInstituto()){
      case '1': case 'MX': this.instituto = 1; break;
      case '2': case 'CAyC': this.instituto = 2; break;
      case '3': case 'HK': this.instituto = 3; break;
      case '4': case 'SGP': this.instituto = 4; break;
      case '5': case 'TK': this.instituto = 5; break;
      case '6': case 'FL': this.instituto = 6; break;
      case '8': case 'IZZI': this.instituto = 8; break;
    }
  }

  checkCorreosGuardados(){
    let idProducto = 0;
    switch (localStorage.getItem('tipoProducto')) {
      case '1': case 'c1': idProducto = 1; break;
      case '2': idProducto = 2; break;
      case 'm1': idProducto = 11;break;
    }
    this.tiposCorreos.forEach((tipoCorreo, i) => {
      let arrIdiomas:any[] = [];
      this.idiomas.forEach(idioma => {
        if(idioma.tipoIdioma != "3"){
          let objIdiomas:any = {};
          objIdiomas.idioma = idioma.nombreIdioma;
          objIdiomas.guardado = false;
          objIdiomas.html = '';
          objIdiomas.asunto = '';
          objIdiomas.piloto = '';
          arrIdiomas.push(objIdiomas);
        }
      });
      tipoCorreo.idiomas = arrIdiomas;
      this.getTemplateGuardado(tipoCorreo, idProducto, i);
    });
    console.log("tiposCorreos:",this.tiposCorreos);

  }

  getTemplateGuardado(tipoCorreo:any, idProducto:number, indice:number){
    let datos: any = {
      productoId: localStorage.getItem('productoID')
    }
    this.programacionService.empresaTemplate(datos).subscribe((respuesta:any) => {
      console.log("respGetTempEmpresa:",respuesta);

      tipoCorreo.idiomas.forEach((idiomaCo,i) => {
        let idx = respuesta.generalCorreos.findIndex(item => item.tipo === this.tiposCorreos[indice].tipo && item.idioma == idiomaCo.idioma);
        console.log("tipo:",tipoCorreo.tipo," idioma:",idiomaCo.idioma," idx:",idx);
        if(idx != -1){
          this.tiposCorreos[indice].idiomas[i].guardado = true;
          this.tiposCorreos[indice].idiomas[i].html = respuesta.generalCorreos[idx].correo;
          this.tiposCorreos[indice].idiomas[i].asunto = respuesta.generalCorreos[idx].asunto;
          this.tiposCorreos[indice].idiomas[i].piloto = respuesta.generalCorreos[idx].piloto;

            let todosGuardados = true;
            this.tiposCorreos.forEach(tipoCorreo => {
              tipoCorreo.idiomas.forEach(idiomaTipoCo => {
                if(!idiomaTipoCo.guardado){
                  todosGuardados = false;
                }
              });
            });
            if(todosGuardados)
              console.log("todos los correos se encontraron guardados :v ",this.tiposCorreos);
        }
        else{

          let datos: any = {
            tipo: tipoCorreo.tipo,                       //1=invitacion, 2=recordatorio
            idProducto,                 //clave del producto, 1=certificar, 2=medirv1,... etc
            productoId: localStorage.getItem('productoID')
          };
          this.getTemplateBase(datos, indice, idiomaCo.idioma);

        }
      });

    });
  }

  getTemplateBase(datos:any, indice:number, idioma:string){
    console.log("entro get templatebase:",indice);
    this.programacionService.getTemplate(datos).subscribe((respuesta:any) => {
      console.log("respGetTempBase:",respuesta);
      if (respuesta.message == "Success") {
        let idxCorr = this.tiposCorreos[indice].idiomas.findIndex(item => item.idioma == idioma);
        let idxHTML = respuesta.correosIdiomas.findIndex(item => item.idioma === idioma);
        if(idxHTML != -1){
          this.tiposCorreos[indice].idiomas[idxCorr].html = respuesta.correosIdiomas[idxHTML].correo;
          this.tiposCorreos[indice].idiomas[idxCorr].asunto = respuesta.correosIdiomas[idxHTML].asunto;
          this.tiposCorreos[indice].idiomas[idxCorr].piloto = respuesta.correosIdiomas[idxHTML].piloto;
          this.guardaCorreosPrimeraVez(indice, datos.tipo, this.tiposCorreos[indice].idiomas[idxCorr].html, this.tiposCorreos[indice].idiomas[idxCorr].asunto, this.tiposCorreos[indice].idiomas[idxCorr].piloto, idioma, idxCorr);
        }
        console.log("tiposCorreosAfetr:",this.tiposCorreos);
      }
    });
  }

  guardaCorreosPrimeraVez(indice:number, tipo:number, html:string, asunto:string, piloto:string, idioma:string, indiceIdioma:number){
    console.log("entro guardacorreos1avez:",indice);

    let datos: any = {
      productoId: localStorage.getItem('productoID'),
      tipo,
      html,
      asunto,
      piloto,
      idioma
    };
    console.log("guardaCorreo:",datos);

    this.programacionService.saveTemplate(datos).subscribe( (respuesta:any) => {
      if(respuesta.success){
        this.tiposCorreos[indice].idiomas[indiceIdioma].guardado = true;

        let todosGuardados = true;
        this.tiposCorreos.forEach((tipoCorreo, i) => {
          tipoCorreo.idiomas.forEach(idiomaTipoCo => {
            if(!idiomaTipoCo.guardado){
              todosGuardados = false;
            }
          });
        });
        if(todosGuardados){
          console.log("todos los correos ya se guardaron la primera vez alv :v ",this.tiposCorreos);
        }
      }
    });
  }

  irPaso(numPaso: number, tipoCorreo?: number){
    this.cambiaPaso.emit(numPaso);
    if(tipoCorreo){
      this.enviaDatos(tipoCorreo);
    }
  }

  enviaDatos(tipo:number){
    // let idProducto = 0;
    // let idPaquete = 0;
    // switch (localStorage.getItem('tipoProducto')) {
    //   case '1': case 'c1':
    //     idProducto = 1;
    //     idPaquete = 1
    //   break;
    // }
    // let datos: any = {
    //   tipo,                       //1=invitacion, 2=recordatorio
    //   idPaquete,                  //1 es certificar v1 y v2, 2 es nom good y better, 3 los medires, 4 pulse, 5 focus
    //   idProducto,                 //clave del producto, 1=certificar, 2=medirv1,... etc
    //   instituto: this.instituto,  //id instituto
    //   clave: this.claveNativo     //clave idioma
    // };
    let indice = this.tiposCorreos.findIndex(item => item.tipo == tipo);
    this.enviaDatosEditor.emit(this.tiposCorreos[indice]);
  }

}
